module.exports = __webpack_public_path__ + "static/img/smartProduct2.c2fe7223.png";